import { useEffect, useState } from 'react';
import { SpringSystem } from 'rebound';
var useSpring = function (targetValue, tension, friction) {
    if (targetValue === void 0) { targetValue = 0; }
    if (tension === void 0) { tension = 50; }
    if (friction === void 0) { friction = 3; }
    var _a = useState(null), spring = _a[0], setSpring = _a[1];
    var _b = useState(targetValue), value = _b[0], setValue = _b[1];
    useEffect(function () {
        var listener = {
            onSpringUpdate: function (currentSpring) {
                var newValue = currentSpring.getCurrentValue();
                setValue(newValue);
            },
        };
        if (!spring) {
            var newSpring = new SpringSystem().createSpring(tension, friction);
            newSpring.setCurrentValue(targetValue);
            setSpring(newSpring);
            newSpring.addListener(listener);
            return;
        }
        return function () {
            spring.removeListener(listener);
            setSpring(null);
        };
    }, [tension, friction]);
    useEffect(function () {
        if (spring) {
            spring.setEndValue(targetValue);
        }
    }, [targetValue]);
    return value;
};
export default useSpring;
